import type { TenantModules } from "@loot-os/api-contract";
import { skipToken, useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";

import { useTRPC } from "./trpc";

/**
 * The route's tenant's modules, resolved (`tenant.get`, the query the tenant chrome already
 * runs); null while loading or outside a tenant. A courtesy for hiding pages: the server refuses
 * a switched-off module's writes for real.
 */
export function useTenantModules(): TenantModules | null {
  const trpc = useTRPC();
  const { tenantId } = useParams({ strict: false }) as { tenantId?: string };
  const tenant = useQuery(trpc.tenant.get.queryOptions(tenantId ? undefined : skipToken));
  return tenant.data?.modules ?? null;
}
